<style>
.radio {
    cursor: pointer;
}

.questionScreenForm h4 {
    font-size: 15px;
}

.form-textarea-input {
    border: none;
    width: 100%;
    border: 1px solid grey;
}

.form-text-input {
    border: none;
    border-bottom: 1px solid #bebbbb;
}

#approximate_vol,
#approximate_vol_both {
    width: 15% !important;
}

input:focus, textarea:focus {
    outline: none;
}
.padded-input {
    padding-left: 5px !important;
}
</style>
<template>
    <form class="mt-2" id="form-modal">
        <!-- {{ renderOnboardingRecord }} -->
        {{ getOnboardingQuestions }}
        <!-- Question 1 -->
        <div class="form-group" style="color: #707070">
            <div class="form-check questionScreenForm" type-data="processing_type">
                <input class="form-check-input radio" type="radio" name="flexRadioDefault" id="flexRadioDefault1"
                    v-model="processingType" value="Customer Owned Goods" @click="isCheck(1)" />
                <label class="form-check-label" for="flexRadioDefault1">
                    Customer Owned Goods
                </label>
            </div>
            <br />
            <div class="form-check questionScreenForm" type-data="processing_type">
                <input class="form-check-input radio" type="radio" name="flexRadioDefault" id="flexRadioDefault2"
                    v-model="processingType" value="Linen Rentals/Linen Hire" @click="isCheck(2)" />
                <label class="form-check-label" for="flexRadioDefault2">
                    Linen Rentals/Linen Hire
                </label>
            </div>
            <br />
            <div class="form-check questionScreenForm" type-data="processing_type">
                <input class="form-check-input radio" type="radio" v-model="processingType"
                    value="Linen Rentals and Customer Owned Goods both" name="flexRadioDefault" id="flexRadioDefault3"
                    @click="isCheck(3)" />
                <label class="form-check-label" for="flexRadioDefault3">
                    Linen Rentals and Customer Owned Goods both
                </label>
            </div>
            <br />

            <div v-if="loading" class="text-center mt-5">Loading...</div>
            <div v-else>
                <div v-if="check || check1 || check2" class="">
                    <!-- FOR COG Customer -->
                    <div v-if="check">
                        <hr />
                        <!-- Question 2 -->
                        <div class="questionScreenForm" type-data="customer">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                Who are your customers?
                            </h4>
                            <div class="questionOptions">
                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input mb-1" type="checkbox" id="hotels" name="hotels"
                                        v-model="customer" value="Hotels">
                                    <label class="form-check-label" for="hotels">Hotels</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input mb-1" type="checkbox" id="restaurants" name="restaurants"
                                        v-model="customer" value="Restaurants">
                                    <label class="form-check-label" for="restaurants">Restaurants</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input mb-1" type="checkbox" id="heathcare" name="heathcare"
                                        v-model="customer" value="Healthcare(Hospitals/Care homes/Clinics)">
                                    <label class="form-check-label" for="heathcare">Healthcare(Hospitals/Care
                                        homes/Clinics)</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input mb-1" type="checkbox" id="vacation" name="vacation"
                                        v-model="customer" value="Vacation Rentals Holiday Homes">
                                    <label class="form-check-label" for="vacation">Vacation Rentals Holiday Homes</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input mb-1" type="checkbox" id="others" name="others"
                                        v-model="customer" value="Others">
                                    <label class="form-check-label" for="others">Others</label>
                                </div>
                            </div>
                        </div>
                        <!-- Question 3 -->
                        <div class="questionScreenForm" type-data="billing_type">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                We bill our customers by
                            </h4>
                            <div class="questionOptions">
                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <input class="form-check-input mb-1" type="radio" id="weight" name="weight"
                                        v-model="billingType" value="Weight">
                                    <label class="form-check-label" for="weight">Weight</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <input class="form-check-input mb-1" type="radio" id="pieceCount" name="pieceCount"
                                        v-model="billingType" value="By Piece Count">
                                    <label class="form-check-label" for="pieceCount">By Piece Count</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <input class="form-check-input mb-1" type="radio" id="fixedBilling" name="fixedBilling"
                                        v-model="billingType" value="Fixed Billing">
                                    <label class="form-check-label" for="fixedBilling">Fixed Billing</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <input class="form-check-input mb-1" type="radio" id="mixedBilling" name="mixedBilling"
                                        v-model="billingType" value="Mixed Billing – By Weight and also by piece">
                                    <label class="form-check-label" for="mixedBilling">Mixed Billing – By Weight and also by
                                        piece</label>
                                </div>
                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <input class="form-check-input mb-1" type="radio" id="otherBilling" name="otherBilling"
                                        v-model="billingType" value="Other">
                                    <label class="form-check-label" for="otherBilling">Other</label>
                                </div>
                            </div>
                        </div>

                        <div class="questionScreenForm" type-data="approximate_vol">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                Approximate volume of linen processed per day
                            </h4>
                            <div class="questionOptions oneLineQuestionOptions">
                                <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                    <p></p><input class="form-text-input mb-1 mr-2" type="text" v-model="approximate_vol"
                                        id="approximate_vol" @input="restrictToNumbersDecimal"> LBS</p>
                                </div>
                            </div>
                        </div>

                        <!-- Question 4 -->
                        <div class="questionScreenForm" type-data="track_cog_soiled_linen">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                We Track Soiled Linen (Dirty Linen) when it comes in from each customer
                            </h4>
                            <div class="questionOptions">
                                <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                    <input class="mb-1 mr-2" type="radio" id="yes" name="track_cog_soiled_linen_radio"
                                        v-model="trackCogSoiledLinen" value="Yes">
                                    <label class="form-check-label" for="yes">Yes</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                    <input class="mb-1 mr-2" type="radio" id="no" name="track_cog_soiled_linen_radio"
                                        v-model="trackCogSoiledLinen" value="No">
                                    <label class="form-check-label" for="no">No</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                    <input class="mb-1 mr-2" type="radio" id="someCustomers"
                                        name="track_cog_soiled_linen_radio" v-model="trackCogSoiledLinen"
                                        value="Only For Some Customers">
                                    <label class="form-check-label" for="someCustomers">Only For Some Customers</label>
                                </div>
                            </div>
                        </div>

                        <!-- Question 5 -->
                        <div class="questionScreenForm" type-data="delivery_purpose">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                For Delivery purpose, we use
                            </h4>
                            <div class="questionOptions">
                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input mb-1" type="checkbox" id="cartsBins" name="cartsBins"
                                        v-model="deliveryPurpose" value="Carts/Bins">
                                    <label class="form-check-label" for="cartsBins">Carts/Bins</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input mb-1" type="checkbox" id="bags" name="bags"
                                        v-model="deliveryPurpose" value="Bags">
                                    <label class="form-check-label" for="bags">Bags</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input mb-1" type="checkbox" id="bagsinsideBins"
                                        name="bagsinsideBins" v-model="deliveryPurpose" value="Bags inside Bins">
                                    <label class="form-check-label" for="bagsinsideBins">Bags inside Bins</label>
                                </div>
                            </div>
                        </div>

                        <!-- Question 6 -->
                        <div class="questionScreenForm" type-data="cart_barcoded">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                Are your Carts/Bins or Bags barcoded?
                            </h4>
                            <div class="questionOptions">
                                <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                    <input class="mb-1 mr-2" type="radio" id="barcodedYes" name="barcoded"
                                        v-model="cartBarcoded" value="YES">
                                    <label class="form-check-label" for="barcodedYes">Yes</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                    <input class="mb-1 mr-2" type="radio" id="barcodedNo" name="barcoded"
                                        v-model="cartBarcoded" value="NO">
                                    <label class="form-check-label crossIcon" for="barcodedNo">No</label>
                                </div>
                                <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                    <input class="mb-1 mr-2" type="radio" id="barcodedWanted" name="barcoded"
                                        v-model="cartBarcoded" value="No, but we would like to have them barcoded.">
                                    <label class="form-check-label crossIcon" for="barcodedWanted">No, but we would like to
                                        have
                                        them
                                        barcoded.</label>
                                </div>
                            </div>
                        </div>

                        <!-- Question 7 -->
                        <div class="questionScreenForm" type-data="billing_type_for_linen_rental">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                Are you currently using any other Software to manage your laundry?
                            </h4>
                            <div class="questionOptions oneLineQuestionOptions">
                                <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                    <input class="mb-1 mr-2" type="radio" id="billing_type_Yes"
                                        name="billing_type_for_linen_rental_yes" v-model="billingTypeForLinenRental"
                                        value="YES">
                                    <label class="form-check-label" for="billing_type_Yes">Yes</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                    <input class="mb-1 mr-2" type="radio" id="billing_type_No"
                                        name="billing_type_for_linen_rental_yes" v-model="billingTypeForLinenRental"
                                        value="NO">
                                    <label class="form-check-label crossIcon" for="billing_type_No">No</label>
                                </div>
                            </div>
                        </div>

                        <!-- Question 8 -->
                        <div class="questionScreenForm" type-data="track_rewash_linen">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                Are you interested in tracking your Rewash Linen, Discarded/Damaged linen etc?
                            </h4>
                            <div class="questionOptions oneLineQuestionOptions">
                                <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                    <input class="mb-1 mr-2" type="radio" id="trackingYes" name="tracking"
                                        v-model="trackRewashLinen" value="YES">
                                    <label class="form-check-label" for="trackingYes">Yes</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                    <input class="mb-1 mr-2" type="radio" id="trackingNo" name="tracking"
                                        v-model="trackRewashLinen" value="NO">
                                    <label class="form-check-label crossIcon" for="trackingNo">No</label>
                                </div>
                            </div>
                        </div>

                        <!-- Question 10 -->
                        <div class="questionScreenForm" type-data="manage_deliveries">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                How do you manage your pick-ups and deliveries?
                            </h4>
                            <div class="questionOptions">
                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input mb-4" type="checkbox" id="assignedRouteDriver"
                                        name="assignedRouteDriver" v-model="manageDeliveries"
                                        value="We have set delivery routes and drivers are assigned to those routes">
                                    <label class="form-check-label" for="assignedRouteDriver">We have set delivery routes
                                        and
                                        drivers are assigned to those routes</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input mb-1" type="checkbox" id="assignedDeliveries"
                                        name="assignedDeliveries" v-model="manageDeliveries"
                                        value="We assign deliveries to drivers on daily basis">
                                    <label class="form-check-label" for="assignedDeliveries">We assign deliveries to drivers
                                        on
                                        daily basis</label>
                                </div>
                            </div>
                        </div>
                        <div class="questionScreenForm" type-data="route">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                How many routes do you run?
                            </h4>
                            <div class="questionOptions oneLineQuestionOptions" id="routeInputsContainer">
                                <div class="form-input py-3 d-flex align-items-center gap-3">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 384 512">
                                        <path
                                            d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" />
                                    </svg>
                                    <input class="form-text-input mb-1 mr-2 padded-input" type="text" id="routeRuns1" v-model="routes" @input="restrictToNumbers">

                                </div>
                            </div>
                        </div>

                        <!-- Question 14 -->
                        <div class="questionScreenForm" type-data="track_rental_soiled_linen">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                What are the key challenges you are trying to solve by using a software? Please mention your
                                key
                                pain points?
                            </h4>
                            <div class="questionOptions">
                                <div class="form-textarea py-3 d-flex align-items-start flex-column gap-3">
                                    <label class="form-textare-label" for="writeAnswerChallenges"></label>
                                    <textarea class="form-textarea-input" type="text" id="writeAnswerChallenges"
                                        name="writeAnswerChallenges" rows="5" style="border:1px solid grey;"
                                        v-model="trackRentalSoiledLinen" placeholder="Write your answer..."></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- FOR Rental Customer -->
                    <div v-if="check1">
                        <hr />
                        <div class="questionScreenForm" type-data="customer_rental">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                Who are your customers?
                            </h4>
                            <div class="questionOptions">
                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input mb-1" type="checkbox" id="hotels_rental"
                                        name="hotels_rental" v-model="customer_rental" value="Hotels">
                                    <label class="form-check-label" for="hotels_rental">Hotels</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input mb-1" type="checkbox" id="restaurants_rental"
                                        name="restaurants_rental" v-model="customer_rental" value="Restaurants">
                                    <label class="form-check-label" for="restaurants_rental">Restaurants</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input mb-1" type="checkbox" id="heathcare_rental"
                                        name="heathcare_rental" v-model="customer_rental"
                                        value="Healthcare(Hospitals/Care homes/Clinics)">
                                    <label class="form-check-label" for="heathcare_rental">Healthcare(Hospitals/Care
                                        homes/Clinics)</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input mb-1" type="checkbox" id="vacation_rental"
                                        name="vacation_rental" v-model="customer_rental"
                                        value="Vacation Rentals Holiday Homes">
                                    <label class="form-check-label" for="vacation_rental">Vacation Rentals Holiday
                                        Homes</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input mb-1" type="checkbox" id="others_rental"
                                        name="others_rental" v-model="customer_rental" value="Others">
                                    <label class="form-check-label" for="others_rental">Others</label>
                                </div>
                            </div>
                        </div>
                        <!-- Question 15 -->
                        <div class="questionScreenForm rentalCustomer" type-data="rfid">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                What is your business model for Linen Hire/Rentals?</h4>
                            <div class="questionOptions">
                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input mb-1" type="checkbox" id="placeOrder" name="placeOrder"
                                        v-model="rfID" value="Our customers place orders and we fulfil them">
                                    <label class="form-check-label" for="placeOrder">Our customers place orders and we
                                        fulfil
                                        them</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input mb-4" type="checkbox" id="nextDelivery"
                                        name="nextDelivery" v-model="rfID"
                                        value="We have a set inventory with the customer. Whatever our customers return, we process and deliver to them on next delivery">
                                    <label class="form-check-label" for="nextDelivery">We have a set inventory with the
                                        customer. Whatever our customers return, we process and deliver to them on next
                                        delivery</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input mb-3" type="checkbox" id="sameQuantity"
                                        name="sameQuantity" v-model="rfID"
                                        value="We have recurring orders set with customer. We deliver them the same quantity every time.">
                                    <label class="form-check-label" for="sameQuantity">We have recurring orders set with
                                        customer. We deliver them the same quantity every time.</label>
                                </div>
                            </div>
                        </div>

                        <!-- Question 16 -->
                        <div class="questionScreenForm rentalCustomer" type-data="hire_rental">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                How do you bill your customers for Linen Rentals/Linen Hire?
                            </h4>
                            <div class="questionOptions">
                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input" type="checkbox" id="deliveredQuantity"
                                        name="deliveredQuantity" v-model="hireRental"
                                        value="For the items delivered quantity">
                                    <label class="form-check-label" for="deliveredQuantity">For the items delivered
                                        quantity</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input" type="checkbox" id="parLevelBilling"
                                        name="parLevelBilling" v-model="hireRental"
                                        value="For the inventory stock we have with them – Par level billing">
                                    <label class="form-check-label" for="parLevelBilling">For the inventory stock we have
                                        with
                                        them – Par level billing</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input" type="checkbox" id="otherSpecify" name="otherSpecify"
                                        v-model="hireRental" value="Other (Please specify)"
                                        @change="checkTextareaBothFunc(1)">
                                    <label class="form-check-label" for="otherSpecify">Other (Please specify)</label>
                                </div>
                                <div v-if="checkTextarea" class="form-check py-1 d-flex align-items-center gap-1">
                                    <textarea class="form-textarea-input" type="text" v-model="hireRentalTextarea"
                                        id="customer_linenRental" name="customer_linenRental" rows="3"
                                        style="border:1px solid grey;"></textarea>
                                </div>
                            </div>
                        </div>

                        <!-- Question 17 -->
                        <div class="questionScreenForm rentalCustomer" type-data="current_software">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                Do you track Soiled linen that comes in from the customer?
                            </h4>
                            <div class="questionOptions">
                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input" type="checkbox" id="manualCount" name="manualCount"
                                        v-model="currentSoftware" value="Yes we do (Manual Counts)">
                                    <label class="form-check-label" for="manualCount">Yes we do (Manual Counts)</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input" type="checkbox" id="throughRFID" name="throughRFID"
                                        v-model="currentSoftware" value="Yes we do through RFID">
                                    <label class="form-check-label" for="throughRFID">Yes we do through RFID</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input" type="checkbox" id="weDoNot" name="weDoNot"
                                        v-model="currentSoftware" value="No we do not?">
                                    <label class="form-check-label" for="weDoNot">No we do not</label>
                                </div>
                            </div>
                        </div>

                        <!-- Question 18 -->
                        <div class="questionScreenForm rentalCustomer" type-data="current_software_chanllanges">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                Are you interested in using RFID for your linen tracking?
                            </h4>
                            <div class="questionOptions oneLineQuestionOptions">
                                <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                    <input class="mb-1 mr-2" type="radio" id="yesRFID" name="RFID"
                                        v-model="currentSoftwareChanllanges" value="YES">
                                    <label class="form-check-label" for="yesRFID"
                                        style="padding-left:0px !important;">Yes</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                    <input class="mb-1 mr-2" type="radio" id="noRFID" name="RFID"
                                        v-model="currentSoftwareChanllanges" value="NO">
                                    <label class="form-check-label" for="noRFID"
                                        style="padding-left:0px !important;">No</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                    <input class="mb-1 mr-2" type="radio" id="alreadyRFID" name="alreadyRFID"
                                    v-model="currentSoftwareChanllanges" value="We are already using it">
                                    <label class="form-check-label" for="alreadyRFID"
                                        style="padding-left:0px !important;">We are already using it</label>
                                </div>
                            </div>
                        </div>

                        <!-- Question 19 -->

                        <div class="questionScreenForm" type-data="manage_deliveries_rental">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                How do you manage your pick-ups and deliveries?
                            </h4>
                            <div class="questionOptions">
                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input mb-4" type="checkbox" id="assignedRouteDriverRental"
                                        name="assignedRouteDriverRental" v-model="manageDeliveriesRental"
                                        value="We have set delivery routes and drivers are assigned to those routes">
                                    <label class="form-check-label" for="assignedRouteDriverRental">We have set delivery
                                        routes
                                        and drivers are assigned to those routes</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input mb-1" type="checkbox" id="assignedDeliveriesRental"
                                        name="assignedDeliveriesRental" v-model="manageDeliveriesRental"
                                        value="We assign deliveries to drivers on daily basis">
                                    <label class="form-check-label" for="assignedDeliveriesRental">We assign deliveries to
                                        drivers on
                                        daily basis</label>
                                </div>
                            </div>
                        </div>

                        <!-- Question 20 -->
                        <div class="questionScreenForm" type-data="track_rewash_linen_rental">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                Are you interested in tracking your Rewash Linen, Discarded/Damaged linen etc?
                            </h4>
                            <div class="questionOptions oneLineQuestionOptions">
                                <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                    <input class="mb-1 mr-2" type="radio" id="track_rewash_linen_rentalYes"
                                        name="track_rewash_linen_rental_radio" v-model="trackRewashLinenRental" value="YES">
                                    <label class="form-check-label" for="track_rewash_linen_rentalYes">Yes</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                    <input class="mb-1 mr-2" type="radio" id="track_rewash_linen_rentalNo"
                                        name="track_rewash_linen_rental_radio" v-model="trackRewashLinenRental" value="NO">
                                    <label class="form-check-label crossIcon" for="track_rewash_linen_rentalNo">No</label>
                                </div>
                            </div>
                        </div>

                        <!-- Question 23 -->
                        <div class="questionScreenForm" type-data="billing_type_for_linen_rental2">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                Are you currently using any other Software to manage your laundry?
                            </h4>
                            <div class="questionOptions oneLineQuestionOptions">
                                <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                    <input class="mb-1 mr-2" type="radio" id="billing_type2_Yes"
                                        name="billing_type_for_linen_rental2_yes" v-model="billingTypeForLinenRental2"
                                        value="YES">
                                    <label class="form-check-label" for="billing_type2_Yes">Yes</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                    <input class="mb-1 mr-2" type="radio" id="billing_type2_No"
                                        name="billing_type_for_linen_rental2_yes" v-model="billingTypeForLinenRental2"
                                        value="NO">
                                    <label class="form-check-label crossIcon" for="billing_type2_No">No</label>
                                </div>
                            </div>
                        </div>

                        <!-- Question 24 -->
                        <div class="questionScreenForm" type-data="track_rental_soiled_linen_rental">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                What are the key challenges you are trying to solve by using a software? Please mention your
                                key
                                pain points?
                            </h4>
                            <div class="questionOptions">
                                <div class="form-textarea py-3 d-flex align-items-start flex-column gap-3">
                                    <label class="form-textare-label" for="writeAnswerChallengesRental"></label>
                                    <textarea class="form-textarea-input" type="text" id="writeAnswerChallengesRental"
                                        name="writeAnswerChallengesRental" rows="5" style="border:1px solid grey;"
                                        v-model="trackRentalSoiledLinenRental" placeholder="Write your answer..."></textarea>
                                </div>
                            </div>
                        </div>

                        <div class="questionScreenForm" type-data="route-rental">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                How many routes do you run?
                            </h4>
                            <div class="questionOptions oneLineQuestionOptions" id="routeInputsContainerRental">
                                <div class="form-input py-3 d-flex align-items-center gap-3">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 384 512">
                                        <path
                                            d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" />
                                    </svg>
                                    <input class="form-text-input mb-1 mr-2 padded-input" type="text" id="routeRunsRental1"
                                        v-model="routeRunsRental" @input="restrictToNumbers">

                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- FOR Both -->
                    <div v-if="check2">
                        <hr />
                        <!-- Question 26 -->
                        <div class="questionScreenForm" type-data="both_customer">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                Who are your customers?
                            </h4>
                            <div class="questionOptions">
                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input mb-1" type="checkbox" v-model="bothCustomer"
                                        value="Hotels" id="both_hotels" name="both_hotels">
                                    <label class="form-check-label" for="both_hotels">Hotels</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input mb-1" type="checkbox" v-model="bothCustomer"
                                        value="Restaurants" id="both_restaurants" name="both_restaurants">
                                    <label class="form-check-label" for="both_restaurants">Restaurants</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input mb-1" type="checkbox" v-model="bothCustomer"
                                        value="Healthcare(Hospitals/Care homes/Clinics)" id="both_heathcare"
                                        name="both_heathcare">
                                    <label class="form-check-label" for="both_heathcare">Healthcare(Hospitals/Care
                                        homes/Clinics)</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input mb-1" type="checkbox" v-model="bothCustomer"
                                        value="Vacation Rentals Holiday Homes" id="both_vacation" name="both_vacation">
                                    <label class="form-check-label" for="both_vacation">Vacation Rentals Holiday
                                        Homes</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input mb-1" type="checkbox" v-model="bothCustomer"
                                        value="Others" id="both_others" name="both_others">
                                    <label class="form-check-label" for="both_others">Others</label>
                                </div>
                            </div>
                        </div>

                        <!-- Question 28 -->
                        <!-- <div class="questionScreenForm" type-data="both_track_cog_soiled_linen">
                        <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                            We Track Soiled Linen (Dirty Linen) when it comes in from each customer
                        </h4>
                        <div class="questionOptions">
                            <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                <input class="mb-1 mr-2" type="radio" v-model="bothTrackCogSoiledLinen" value="Yes"
                                    id="both_track_cog_soiled_linenYes" name="both_track_cog_soiled_linen_radio">
                                <label class="form-check-label" for="both_track_cog_soiled_linenYes">Yes</label>
                            </div>

                            <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                <input class="mb-1 mr-2" type="radio" v-model="bothTrackCogSoiledLinen" value="No"
                                    id="both_track_cog_soiled_linenNo" name="both_track_cog_soiled_linen_radio">
                                <label class="form-check-label" for="both_track_cog_soiled_linenNo">No</label>
                            </div>

                            <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                <input class="mb-1 mr-2" type="radio" v-model="bothTrackCogSoiledLinen"
                                    value="Only For Some Customers" id="both_track_cog_soiled_linen_someCustomers"
                                    name="both_track_cog_soiled_linen_radio">
                                <label class="form-check-label" for="both_track_cog_soiled_linen_someCustomers">Only For
                                    Some Customers</label>
                            </div>
                        </div>
                    </div> -->

                        <!-- Question 29 -->
                        <!-- <div class="questionScreenForm" type-data="both_delivery_purpose">
                        <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                            For Delivery purpose, we use
                        </h4>
                        <div class="questionOptions">
                            <div class="form-check py-1 d-flex align-items-center gap-1">
                                <div class="checkBoxBorder"></div>
                                <input class="form-check-input mb-1" type="checkbox" v-model="bothDeliveryPurpose"
                                    value="Carts/Bins" id="both_cartsBins" name="both_cartsBins">
                                <label class="form-check-label" for="both_cartsBins">Carts/Bins</label>
                            </div>

                            <div class="form-check py-1 d-flex align-items-center gap-1">
                                <div class="checkBoxBorder"></div>
                                <input class="form-check-input mb-1" type="checkbox" v-model="bothDeliveryPurpose"
                                    value="Bags" id="both_bags" name="both_bags">
                                <label class="form-check-label" for="both_bags">Bags</label>
                            </div>

                            <div class="form-check py-1 d-flex align-items-center gap-1">
                                <div class="checkBoxBorder"></div>
                                <input class="form-check-input mb-1" type="checkbox" v-model="bothDeliveryPurpose"
                                    value="Bags inside Bins" id="both_bagsinsideBins" name="both_bagsinsideBins">
                                <label class="form-check-label" for="both_bagsinsideBins">Bags inside Bins</label>
                            </div>
                        </div>
                    </div> -->

                        <!-- Question 30 -->
                        <!-- <div class="questionScreenForm" type-data="both_cart_barcoded">
                        <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                            Are your Carts/Bins or Bags barcoded
                        </h4>
                        <div class="questionOptions">
                            <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                <input class="mb-1 mr-2" type="radio" v-model="bothCartBarcoded" value="YES"
                                    id="both_barcodedYes" name="both_barcoded">
                                <label class="form-check-label" for="both_barcodedYes">Yes</label>
                            </div>

                            <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                <input class="mb-1 mr-2" type="radio" v-model="bothCartBarcoded" value="NO"
                                    id="both_barcodedNo" name="both_barcoded">
                                <label class="form-check-label crossIcon" for="both_barcodedNo">No</label>
                            </div>
                            <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                <input class="mb-1 mr-2" type="radio" v-model="bothCartBarcoded"
                                    value="No, but we would like to have them barcoded." id="both_barcodedWanted"
                                    name="both_barcoded">
                                <label class="form-check-label crossIcon" for="both_barcodedWanted">No, but we would like to
                                    have
                                    them
                                    barcoded.</label>
                            </div>
                        </div>
                    </div> -->

                        <!-- Question 31 -->
                        <div class="questionScreenForm" type-data="both_billing_type_for_linen_rental">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                Are you currently using any other Software to manage your laundry?
                            </h4>
                            <div class="questionOptions oneLineQuestionOptions">
                                <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                    <input class="mb-1 mr-2" type="radio" v-model="bothBillingTypeForLinenRental"
                                        value="YES" id="both_billing_type_Yes"
                                        name="both_billing_type_for_linen_rental_yes">
                                    <label class="form-check-label" for="both_billing_type_Yes">Yes</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                    <input class="mb-1 mr-2" type="radio" v-model="bothBillingTypeForLinenRental" value="NO"
                                        id="both_billing_type_No" name="both_billing_type_for_linen_rental_yes">
                                    <label class="form-check-label crossIcon" for="both_billing_type_No">No</label>
                                </div>
                            </div>
                        </div>

                        <!-- Question 32 -->
                        <div class="questionScreenForm" type-data="both_track_rewash_linen_rental">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                Are you interested in tracking your Rewash Linen, Discarded/Damaged linen etc?
                            </h4>
                            <div class="questionOptions oneLineQuestionOptions">
                                <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                    <input class="mb-1 mr-2" type="radio" v-model="bothTrackRewashLinen" value="YES"
                                        id="both_trackingYes" name="both_tracking">
                                    <label class="form-check-label" for="both_trackingYes">Yes</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                    <input class="mb-1 mr-2" type="radio" v-model="bothTrackRewashLinen" value="NO"
                                        id="both_trackingNo" name="both_tracking">
                                    <label class="form-check-label crossIcon" for="both_trackingNo">No</label>
                                </div>
                            </div>
                        </div>

                        <!-- Question 34 -->
                        <div class="questionScreenForm" type-data="both_manage_deliveries">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                How do you manage your pick-ups and deliveries?
                            </h4>
                            <div class="questionOptions">
                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input mb-4" type="checkbox" v-model="bothManageDeliveries"
                                        value="We have set delivery routes and drivers are assigned to those routes"
                                        id="both_assignedRouteDriver" name="both_assignedRouteDriver">
                                    <label class="form-check-label" for="both_assignedRouteDriver">We have set delivery
                                        routes
                                        and drivers are assigned to those routes</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input mb-1" type="checkbox" v-model="bothManageDeliveries"
                                        value="We assign deliveries to drivers on daily basis" id="both_assignedDeliveries"
                                        name="both_assignedDeliveries">
                                    <label class="form-check-label" for="both_assignedDeliveries">We assign deliveries to
                                        drivers on
                                        daily basis</label>
                                </div>
                            </div>
                        </div>

                        <div class="questionScreenForm" type-data="both_route">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                How many routes do you run?
                            </h4>
                            <div class="questionOptions oneLineQuestionOptions" id="both_routeInputsContainer">
                                <div class="form-input py-3 d-flex align-items-center gap-3">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 384 512">
                                        <path
                                            d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" />
                                    </svg>
                                    <input class="form-text-input mb-1 mr-2 padded-input" type="text" id="both_routeRuns1"
                                        v-model="both_routeRuns" @input="restrictToNumbers">

                                </div>
                            </div>
                        </div>

                        <!-- Question 38 -->
                        <!-- Question 24 -->
                        <div class="questionScreenForm" type-data="both_track_rental_soiled_linen_rental">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                What are the key challenges you are trying to solve by using a software? Please mention your
                                key
                                pain points?
                            </h4>
                            <div class="questionOptions">
                                <div class="form-textarea py-3 d-flex align-items-start flex-column gap-3">
                                    <label class="form-textare-label" for="both_writeAnswerChallengesRental"></label>
                                    <textarea class="form-textarea-input" type="text" id="both_writeAnswerChallengesRental"
                                        name="both_writeAnswerChallengesRental" rows="5" style="border:1px solid grey;"
                                        v-model="bothTrackRentalSoiledLinenRental" placeholder="Write your answer..."></textarea>
                                </div>
                            </div>
                        </div>

                        <!-- Question 39 -->
                        <div class="questionScreenForm rentalCustomer" type-data="both_rfid">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                What is your business model for Linen Hire/Rentals? </h4>
                            <div class="questionOptions">
                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input mb-1" type="checkbox" v-model="bothRfid"
                                        value="Our customers place orders and we fulfil them" id="both_placeOrder"
                                        name="both_placeOrder">
                                    <label class="form-check-label" for="both_placeOrder">Our customers place orders and we
                                        fulfil
                                        them</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input mb-4" type="checkbox" v-model="bothRfid"
                                        value="We have a set inventory with the customer. Whatever our customers return, we process and deliver to them on next delivery"
                                        id="both_nextDelivery" name="both_nextDelivery">
                                    <label class="form-check-label" for="both_nextDelivery">We have a set inventory with the
                                        customer. Whatever our customers return, we process and deliver to them on next
                                        delivery</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input mb-3" type="checkbox" v-model="bothRfid"
                                        value="We have recurring orders set with customer. We deliver them the same quantity every time."
                                        id="both_sameQuantity" name="both_sameQuantity">
                                    <label class="form-check-label" for="both_sameQuantity">We have recurring orders set
                                        with
                                        customer. We deliver them the same quantity every time.</label>
                                </div>
                            </div>
                        </div>

                        <!-- Question 40 -->
                        <div class="questionScreenForm rentalCustomer" type-data="both_hire_rental">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                How do you bill your customers for Linen Rentals/Linen Hire?
                            </h4>
                            <div class="questionOptions">
                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input" type="checkbox" v-model="bothHireRental"
                                        value="For the items delivered quantity" id="both_deliveredQuantity"
                                        name="both_deliveredQuantity">
                                    <label class="form-check-label" for="both_deliveredQuantity">For the items delivered
                                        quantity</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input" type="checkbox" v-model="bothHireRental"
                                        value="For the inventory stock we have with them – Par level billing"
                                        id="both_parLevelBilling" name="both_parLevelBilling">
                                    <label class="form-check-label" for="both_parLevelBilling">For the inventory stock we
                                        have
                                        with
                                        them – Par level billing</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input" type="checkbox" v-model="bothHireRental"
                                        value="Other (Please specify)" id="both_otherSpecify" name="both_otherSpecify"
                                        @change="checkTextareaBothFunc(2)">
                                    <label class="form-check-label" for="both_otherSpecify">Other (Please specify)</label>
                                </div>
                                <div v-if="checkTextareaBoth" class="form-check py-1 d-flex align-items-center gap-1">
                                    <textarea class="form-textarea-input" type="text" v-model="bothHireRentalTextarea"
                                        id="customer_linenRental_both" name="customer_linenRental_both" rows="3"
                                        style="border:1px solid grey;"></textarea>
                                </div>
                            </div>
                        </div>

                        <!-- Question 41 -->
                        <div class="questionScreenForm rentalCustomer" type-data="both_current_software">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                Do you track Soiled linen that comes in from the customer?
                            </h4>
                            <div class="questionOptions">
                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input" type="checkbox" v-model="bothCurrentSoftware"
                                        value="Yes we do (Manual Counts)" id="both_manualCount" name="both_manualCount">
                                    <label class="form-check-label" for="both_manualCount">Yes we do (Manual Counts)</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input" type="checkbox" v-model="bothCurrentSoftware"
                                        value="Yes we do through RFID" id="both_throughRFID" name="both_throughRFID">
                                    <label class="form-check-label" for="both_throughRFID">Yes we do through RFID</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1">
                                    <div class="checkBoxBorder"></div>
                                    <input class="form-check-input" type="checkbox" v-model="bothCurrentSoftware"
                                        value="No we do not?" id="both_weDoNot" name="both_weDoNot">
                                    <label class="form-check-label" for="both_weDoNot">No we do not</label>
                                </div>
                            </div>
                        </div>

                        <!-- Question 42 -->
                        <!-- <div class="questionScreenForm rentalCustomer" type-data="both_current_software_chanllanges">
                        <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                            Are you interested in using RFID for your linen tracking?
                        </h4>
                        <div class="questionOptions oneLineQuestionOptions">
                            <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                <input class="mb-1 mr-2" type="radio" v-model="bothCurrentSoftwareChanllanges" value="YES"
                                    id="both_yesRFID" name="both_RFID">
                                <label class="form-check-label" for="both_yesRFID"
                                    style="padding-left:0px !important;">Yes</label>
                            </div>

                            <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                <input class="mb-1 mr-2" type="radio" v-model="bothCurrentSoftwareChanllanges" value="NO"
                                    id="both_noRFID" name="both_RFID">
                                <label class="form-check-label" for="both_noRFID"
                                    style="padding-left:0px !important;">No</label>
                            </div>
                        </div>
                    </div> -->

                        <div class="questionScreenForm" type-data="both-business">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                What percentage of your business is Rentals versus Customer Owned Goods?
                            </h4>
                            <div class="questionOptions oneLineQuestionOptions">
                                <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                    <p>Linen Rentals is about <input class="form-text-input mb-1 mr-2" type="text"
                                            v-model="both_business" style="width:8%;" id="both_business_input" @input="restrictToNumbersDecimal"> Percent of our business and rest is
                                        COG.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="questionScreenForm" type-data="customer_owned_license">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                For your customers where your Process Customer Owned Linens(COG) how do you bill your
                                customers
                            </h4>
                            <div class="questionOptions oneLineQuestionOptions">
                                <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                    <input class="mb-1 mr-2" type="radio" v-model="customer_owned_license_val"
                                        value="Weight" id="weight_license">
                                    <label class="form-check-label" for="weight_license"
                                        style="padding-left:0px !important;">Weight</label>
                                </div>

                                <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                    <input class="mb-1 mr-2" type="radio" v-model="customer_owned_license_val"
                                        value="By Piece Count" id="by_piece_license">
                                    <label class="form-check-label" for="by_piece_license"
                                        style="padding-left:0px !important;">By Piece Count</label>
                                </div>
                                <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                    <input class="mb-1 mr-2" type="radio" v-model="customer_owned_license_val"
                                        value="Fixed Billing" id="fixed_license">
                                    <label class="form-check-label" for="fixed_license"
                                        style="padding-left:0px !important;">Fixed Billing</label>
                                </div>
                                <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                    <input class="mb-1 mr-2" type="radio" v-model="customer_owned_license_val"
                                        value="Mixed Billing – By Weight and also by piece" id="mixed_biling_license">
                                    <label class="form-check-label" for="mixed_biling_license"
                                        style="padding-left:0px !important;">Mixed Billing – By Weight and also by
                                        piece</label>
                                </div>
                                <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                    <input class="mb-1 mr-2" type="radio" v-model="customer_owned_license_val" value="Other"
                                        id="other_license">
                                    <label class="form-check-label" for="other_license"
                                        style="padding-left:0px !important;">Other</label>
                                </div>
                            </div>
                        </div>

                        <div class="questionScreenForm" type-data="approximate_vol_both">
                            <h4 class="headingQuestion color-default font-weight-bold mb-3 mt-3">
                                Approximate volume of linen processed per day
                            </h4>
                            <div class="questionOptions oneLineQuestionOptions">
                                <div class="form-check py-1 d-flex align-items-center gap-1 p-0">
                                    <p><input class="form-text-input mb-1 mr-2" type="text" v-model="approximate_vol_both"
                                            id="approximate_vol_both" @input="restrictToNumbersDecimal"> LBS</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div v-if="loading"></div>
        <div v-else>

            <div class="form-footer text-right" v-if="check || check1 || check2">
                <button type="button" class="btn btn-secondary text-light" data-dismiss="modal">
                    Close
                </button>
                <button type="button" :style="[isMiniLoading ? { 'cursor': 'default' } : { 'cursor': 'pointer' }]"
                    :disabled="isMiniLoading" class="btn btn-default text-light ml-1" @click="save">
                    <font-awesome-icon v-if="isMiniLoading" icon="spinner"
                        style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
                    Save
                </button>
            </div>
        </div>


    </form>
</template>

<script>
import axios from "axios";
export default {
    props: ["action", "formData"],
    data: function () {
        return {
            isMiniLoading: false,
            track_soiled_linen: "",
            rental_delivery_routs: "",
            cog_devlivery_routes: "",
            we_do_tracking: "",
            pricing_structure: "",
            barcoding_carts: "",
            billing_process: "",
            bill_for: [],
            rental_methods: [],
            other_method: "",
            other_method1: "",
            cog_percentage: "",
            prospection_question: "",
            checked: false,
            checked1: false,
            check: false,
            check1: false,
            check2: false,
            processing_type: '',
            checkValue: '',
            executeSpecificPart: true,
            previousLeadID: 0,
            loading: true,
            // COG
            processingType: '',
            customer: [],
            billingType: [],
            trackCogSoiledLinen: '',
            deliveryPurpose: [],
            cartBarcoded: '',
            billingTypeForLinenRental: '',
            trackRewashLinen: [],
            manageDeliveries: [],
            routes: '',
            trackRentalSoiledLinen: '',
            approximate_vol: '',
            // Rental
            customer_rental: [],
            rfID: [],
            hireRental: [],
            currentSoftware: [],
            currentSoftwareChanllanges: '',
            manageDeliveriesRental: [],
            trackRewashLinenRental: '',
            billingTypeForLinenRental2: '',
            trackRentalSoiledLinenRental: '',
            routeRunsRental: '',
            hireRentalTextarea: '',
            checkTextarea: false,
            // Both
            bothCustomer: [],
            bothBillingType: [],
            bothTrackCogSoiledLinen: '',
            bothDeliveryPurpose: [],
            bothCartBarcoded: '',
            bothBillingTypeForLinenRental: '',
            bothTrackRewashLinen: '',
            bothManageDeliveries: [],
            bothRouteRunRentals: '',
            both_routeRuns: '',
            bothTrackRentalSoiledLinenRental: '',
            bothRfid: [],
            bothHireRental: [],
            bothCurrentSoftware: [],
            bothCurrentSoftwareChanllanges: '',
            customer_owned_license_val: '',
            both_business: '',
            approximate_vol_both: '',
            bothHireRentalTextarea: '',
            checkTextareaBoth: false
        };
    },
    computed: {
        getOnboardingQuestions: function () {
            this.loading = true;
              const permission = {
      headers: {
        'X-Permission': 'lead_prospection_question' 
      }
    };
            axios.get(`/admin/users/get-lead-questionnaire/${this.formData.lead_id}`,permission)
                .then((response) => {
                    let questionnaires = response.data.leadWithData.lead_questionnaires;
                    // Processing Type (COG, Renttal, Both)
                    let processingTypeQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'processing_type'
                    );
                    this.processingType = processingTypeQuestion ? processingTypeQuestion.lead_questionnaire_answers[0].answer : '';
                    // if (this.executeSpecificPart) {
                    if (this.processingType === 'Customer Owned Goods') {
                        this.check1 = false;
                        this.check2 = false;
                        this.check = true;
                        this.checkValue = 1;
                    } else if (this.processingType === 'Linen Rentals/Linen Hire') {
                        this.check = false;
                        this.check2 = false;
                        this.check1 = true;
                        this.checkValue = 2;
                    } else if (this.processingType === 'Linen Rentals and Customer Owned Goods both') {
                        this.check = false;
                        this.check1 = false;
                        this.check2 = true;
                        this.checkValue = 3;
                    }
                    // }
                    // COG
                    let customerQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'customer'
                    );
                    this.customer = customerQuestion ? customerQuestion.lead_questionnaire_answers.map(answer => answer.answer) : [];

                    let billingTypeQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'billing_type'
                    );
                    this.billingType = billingTypeQuestion ? billingTypeQuestion.lead_questionnaire_answers[0].answer : '';

                    let trackCogSoiledLinenQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'track_cog_soiled_linen'
                    );
                    this.trackCogSoiledLinen = trackCogSoiledLinenQuestion ? trackCogSoiledLinenQuestion.lead_questionnaire_answers[0].answer : '';

                    let deliveryPurposeQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'delivery_purpose'
                    );
                    this.deliveryPurpose = deliveryPurposeQuestion ? deliveryPurposeQuestion.lead_questionnaire_answers.map(answer => answer.answer) : [];

                    let cartBarcodedQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'cart_barcoded'
                    );
                    this.cartBarcoded = cartBarcodedQuestion ? cartBarcodedQuestion.lead_questionnaire_answers[0].answer : '';

                    let billingTypeForLinenRentalQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'billing_type_for_linen_rental'
                    );
                    this.billingTypeForLinenRental = billingTypeForLinenRentalQuestion ? billingTypeForLinenRentalQuestion.lead_questionnaire_answers[0].answer : '';

                    let trackRewashLinenQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'track_rewash_linen'
                    );
                    this.trackRewashLinen = trackRewashLinenQuestion ? trackRewashLinenQuestion.lead_questionnaire_answers[0].answer : [];

                    let manageDeliveriesQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'manage_deliveries'
                    );
                    this.manageDeliveries = manageDeliveriesQuestion ? manageDeliveriesQuestion.lead_questionnaire_answers.map(answer => answer.answer) : [];

                    let routesQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'route'
                    );
                    this.routes = routesQuestion ? routesQuestion.lead_questionnaire_answers.map(answer => { return answer.answer.split('?ques_id')[0]; }) : [];

                    let approximate_volQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'approximate_vol'
                    );
                    this.approximate_vol = approximate_volQuestion ? approximate_volQuestion.lead_questionnaire_answers.map(answer => { return answer.answer.split('?ques_id')[0]; }) : [];

                    let trackRentalSoiledLinenQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'track_rental_soiled_linen'
                    );
                    this.trackRentalSoiledLinen = trackRentalSoiledLinenQuestion ? trackRentalSoiledLinenQuestion.lead_questionnaire_answers[0].answer.replace('?ques_id=writeAnswerChallenges', '') : '';

                    // Rental
                    let customer_rentalQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'customer_rental'
                    );
                    this.customer_rental = customer_rentalQuestion ? customer_rentalQuestion.lead_questionnaire_answers.map(answer => answer.answer) : [];

                    let rfidQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'rfid'
                    );
                    this.rfID = rfidQuestion ? rfidQuestion.lead_questionnaire_answers.map(answer => answer.answer) : [];

                    let hireRentalQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'hire_rental'
                    );
                    this.hireRental = hireRentalQuestion ? hireRentalQuestion.lead_questionnaire_answers.map(answer => answer.answer) : [];

                    if (this.hireRental.includes('Other (Please specify)')) {
                        this.checkTextareaBothFunc(1);
                    }

                    if (this.hireRental.length > 0) {
                        let extractedValues = this.hireRental.filter(value => value.includes('customer_linenRental'));
                        this.hireRentalTextarea = extractedValues.map(value => value.split('?ques_id=customer_linenRental')[0]);
                    }

                    let currentSoftwareQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'current_software'
                    );
                    this.currentSoftware = currentSoftwareQuestion ? currentSoftwareQuestion.lead_questionnaire_answers.map(answer => answer.answer) : [];

                    let currentSoftwareChanllangesQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'current_software_chanllanges'
                    );
                    this.currentSoftwareChanllanges = currentSoftwareChanllangesQuestion ? currentSoftwareChanllangesQuestion.lead_questionnaire_answers[0].answer : '';

                    let manageDeliveriesRentalQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'manage_deliveries_rental'
                    );
                    this.manageDeliveriesRental = manageDeliveriesRentalQuestion ? manageDeliveriesRentalQuestion.lead_questionnaire_answers.map(answer => answer.answer) : [];

                    let trackRewashLinenRentalQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'track_rewash_linen_rental'
                    );
                    this.trackRewashLinenRental = trackRewashLinenRentalQuestion ? trackRewashLinenRentalQuestion.lead_questionnaire_answers[0].answer : '';

                    let billingTypeForLinenRental2Question = questionnaires.find(
                        questionnaire => questionnaire.type === 'billing_type_for_linen_rental2'
                    );
                    this.billingTypeForLinenRental2 = billingTypeForLinenRental2Question ? billingTypeForLinenRental2Question.lead_questionnaire_answers[0].answer : '';

                    let trackRentalSoiledLinenRentalQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'track_rental_soiled_linen_rental'
                    );
                    this.trackRentalSoiledLinenRental = trackRentalSoiledLinenRentalQuestion ? trackRentalSoiledLinenRentalQuestion.lead_questionnaire_answers[0].answer.replace('?ques_id=writeAnswerChallengesRental', '') : '';

                    let routeRunsRentalQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'route-rental'
                    );
                    this.routeRunsRental = routeRunsRentalQuestion ? routeRunsRentalQuestion.lead_questionnaire_answers.map(answer => { return answer.answer.split('?ques_id')[0]; }) : [];

                    // Both
                    let bothCustomerQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'both_customer'
                    );
                    this.bothCustomer = bothCustomerQuestion ? bothCustomerQuestion.lead_questionnaire_answers.map(answer => answer.answer) : [];

                    let bothBillingTypeQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'both_billing_type'
                    );
                    this.bothBillingType = bothBillingTypeQuestion ? bothBillingTypeQuestion.lead_questionnaire_answers.map(answer => answer.answer) : [];

                    let bothTrackCogSoiledLinenQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'both_track_cog_soiled_linen'
                    );
                    this.bothTrackCogSoiledLinen = bothTrackCogSoiledLinenQuestion ? bothTrackCogSoiledLinenQuestion.lead_questionnaire_answers[0].answer : '';

                    let bothDeliveryPurposeQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'both_delivery_purpose'
                    );
                    this.bothDeliveryPurpose = bothDeliveryPurposeQuestion ? bothDeliveryPurposeQuestion.lead_questionnaire_answers.map(answer => answer.answer) : [];

                    let bothCartBarcodedQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'both_cart_barcoded'
                    );
                    this.bothCartBarcoded = bothCartBarcodedQuestion ? bothCartBarcodedQuestion.lead_questionnaire_answers[0].answer : '';

                    let bothBillingTypeForLinenRentalQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'both_billing_type_for_linen_rental'
                    );
                    this.bothBillingTypeForLinenRental = bothBillingTypeForLinenRentalQuestion ? bothBillingTypeForLinenRentalQuestion.lead_questionnaire_answers[0].answer : '';

                    let bothTrackRewashLinenQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'both_track_rewash_linen_rental'
                    );
                    this.bothTrackRewashLinen = bothTrackRewashLinenQuestion ? bothTrackRewashLinenQuestion.lead_questionnaire_answers[0].answer : '';

                    let bothManageDeliveriesQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'both_manage_deliveries'
                    );
                    this.bothManageDeliveries = bothManageDeliveriesQuestion ? bothManageDeliveriesQuestion.lead_questionnaire_answers.map(answer => answer.answer) : [];

                    let bothRouteRunRentalsQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'both_route'
                    );
                    this.both_routeRuns = bothRouteRunRentalsQuestion ? bothRouteRunRentalsQuestion.lead_questionnaire_answers.map(answer => { return answer.answer.split('?ques_id')[0]; }) : [];

                    let bothTrackRentalSoiledLinenRentalQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'both_track_rental_soiled_linen_rental'
                    );
                    this.bothTrackRentalSoiledLinenRental = bothTrackRentalSoiledLinenRentalQuestion ? bothTrackRentalSoiledLinenRentalQuestion.lead_questionnaire_answers[0].answer.replace('?ques_id=both_writeAnswerChallengesRental', '') : '';

                    let bothRfidQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'both_rfid'
                    );
                    this.bothRfid = bothRfidQuestion ? bothRfidQuestion.lead_questionnaire_answers.map(answer => answer.answer) : [];

                    let bothHireRentalQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'both_hire_rental'
                    );
                    this.bothHireRental = bothHireRentalQuestion ? bothHireRentalQuestion.lead_questionnaire_answers.map(answer => answer.answer) : [];

                    if (this.bothHireRental.includes('Other (Please specify)')) {
                        this.checkTextareaBothFunc(2);
                    }

                    if (this.bothHireRental.length > 0) {
                        let extractedValuesBoth = this.bothHireRental.filter(value => value.includes('customer_linenRental_both'));
                        this.bothHireRentalTextarea = extractedValuesBoth.map(value => value.split('?ques_id=customer_linenRental_both')[0]);
                    }

                    let bothCurrentSoftwareQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'both_current_software'
                    );
                    this.bothCurrentSoftware = bothCurrentSoftwareQuestion ? bothCurrentSoftwareQuestion.lead_questionnaire_answers.map(answer => answer.answer) : [];

                    let bothCurrentSoftwareChanllangesQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'both_current_software_chanllanges'
                    );
                    this.bothCurrentSoftwareChanllanges = bothCurrentSoftwareChanllangesQuestion ? bothCurrentSoftwareChanllangesQuestion.lead_questionnaire_answers[0].answer : '';

                    let customer_owned_license_valQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'customer_owned_license'
                    );
                    this.customer_owned_license_val = customer_owned_license_valQuestion ? customer_owned_license_valQuestion.lead_questionnaire_answers[0].answer : '';

                    let both_businessQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'both-business'
                    );
                    this.both_business = both_businessQuestion ? both_businessQuestion.lead_questionnaire_answers[0].answer.replace('?ques_id=business_rental', '') : '';

                    let approximate_vol_bothQuestion = questionnaires.find(
                        questionnaire => questionnaire.type === 'approximate_vol_both'
                    );
                    this.approximate_vol_both = approximate_vol_bothQuestion ? approximate_vol_bothQuestion.lead_questionnaire_answers.map(answer => { return answer.answer.split('?ques_id')[0]; }) : [];
                    this.loading = false;
                })
                .catch((error) => {
                    console.error('Error fetching data:', error);
                    this.loading = false;
                });
        },
        checkedComputed() {
            return this.rental_methods;
        },
        checkedbill() {
            return this.bill_for;
        },
    },
    methods: {
        checkTextareaBothFunc(event) {
            if (event === 1) {
                if (this.hireRental.includes('Other (Please specify)')) {
                    this.checkTextarea = true;
                } else {
                    this.checkTextarea = false;
                }
            } else {
                if (this.bothHireRental.includes('Other (Please specify)')) {
                    this.checkTextareaBoth = true;
                } else {
                    this.checkTextareaBoth = false;
                }
            }
        },
        restrictToNumbers(event) {
            const inputValueCheck = event.target.value;
            const numericValueCheck = inputValueCheck.replace(/\D/g, '');

            switch (event.target.id) {
                case 'routeRuns1':
                    this.routes = numericValueCheck;
                    break;
                case 'routeRunsRental1':
                    this.routeRunsRental = numericValueCheck;
                    break;
                case 'both_routeRuns1':
                    this.both_routeRuns = numericValueCheck;
                    break;
                default:
                    break;
            }
        },
        restrictToNumbersDecimal(event) {
            const inputValueCheckDecimal = event.target.value;
            const numericValueCheckDecimal = inputValueCheckDecimal.replace(/[^\d.]/g, '');

            switch (event.target.id) {
                case 'approximate_vol':
                    this.approximate_vol = numericValueCheckDecimal;
                    break;
                case 'both_business_input':
                    this.both_business = numericValueCheckDecimal;
                    break;
                case 'approximate_vol_both':
                    this.approximate_vol_both = numericValueCheckDecimal;
                    break;
                default:
                    break;
            }
        },
        save() {
            this.isMiniLoading = true;
            if (this.hireRental.includes('Other (Please specify)')) {
                const searchText = '?ques_id=customer_linenRental';
                const elementsToRemove = this.hireRental.filter(item => item.includes(searchText));
                elementsToRemove.forEach(item => {
                    const indexToRemove = this.hireRental.indexOf(item);
                    if (indexToRemove !== -1) {
                        this.hireRental.splice(indexToRemove, 1);
                    }
                });
                this.hireRental.push(`${this.hireRentalTextarea}${searchText}`);
            }

            if (this.bothHireRental.includes('Other (Please specify)')) {
                const searchTextBoth = '?ques_id=customer_linenRental_both';
                const elementsToRemoveBoth = this.bothHireRental.filter(item => item.includes(searchTextBoth));
                elementsToRemoveBoth.forEach(item => {
                    const indexToRemoveBoth = this.bothHireRental.indexOf(item);
                    if (indexToRemoveBoth !== -1) {
                        this.bothHireRental.splice(indexToRemoveBoth, 1);
                    }
                });
                this.bothHireRental.push(`${this.bothHireRentalTextarea}${searchTextBoth}`);
            }

            const formDataCOG = [
                {
                    question_type: 'processing_type',
                    question_data: "Processing Type (Please select what represents the major part of your business e.g) If its 70 percent rentals and 30 percent COG then select rentals.",
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: [this.processingType]
                },
                {
                    question_type: 'customer',
                    question_data: 'Who are your customers?',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: this.customer
                },
                {
                    question_type: 'billing_type',
                    question_data: 'We bill our customers by',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: this.billingType
                },
                {
                    question_type: 'track_cog_soiled_linen',
                    question_data: 'We Track Soiled Linen (Dirty Linen) when it comes in from each customer',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: [this.trackCogSoiledLinen]
                },
                {
                    question_type: 'delivery_purpose',
                    question_data: 'For Delivery purpose, we use',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: this.deliveryPurpose
                },
                {
                    question_type: 'cart_barcoded',
                    question_data: 'Are your Carts/Bins or Bags barcoded?',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: [this.cartBarcoded]
                },
                {
                    question_type: 'billing_type_for_linen_rental',
                    question_data: 'Are you currently using any other Software to manage your laundry?',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: [this.billingTypeForLinenRental]
                },
                {
                    question_type: 'track_rewash_linen',
                    question_data: 'Are you interested in tracking your Rewash Linen, Discarded/Damaged linen etc?',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: this.trackRewashLinen
                },
                {
                    question_type: 'manage_deliveries',
                    question_data: 'How do you manage your pick-ups and deliveries?',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: this.manageDeliveries
                },
                {
                    question_type: 'route',
                    question_data: 'How many routes do you run?',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: this.routes != '' ? [this.routes] + '?ques_id=routeRuns1' : ''
                },
                {
                    question_type: 'approximate_vol',
                    question_data: 'Approximate volume of linen processed per day',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: this.approximate_vol != '' ? [this.approximate_vol] + '?ques_id=approximate_vol' : ''
                },
                {
                    question_type: 'track_rental_soiled_linen',
                    question_data: 'What are the key challenges you are trying to solve by using a software? Please mention your key pain points?',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: this.trackRentalSoiledLinen != '' ? [this.trackRentalSoiledLinen + '?ques_id=writeAnswerChallenges'] : ''
                }
            ];

            // Rental
            const formDataRental = [
                {
                    question_type: 'processing_type',
                    question_data: "Processing Type (Please select what represents the major part of your business e.g) If its 70 percent rentals and 30 percent COG then select rentals.",
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: [this.processingType]
                },
                {
                    question_type: 'customer_rental',
                    question_data: 'Who are your customers?',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: this.customer_rental
                },
                {
                    question_type: 'rfid',
                    question_data: 'What is your business model for Linen Hire/Rental?',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: this.rfID
                },
                {
                    question_type: 'hire_rental',
                    question_data: 'How do you bill your customers for Linen Rentals/Linen Hires?',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: this.hireRental
                },
                {
                    question_type: 'current_software',
                    question_data: 'Do you track Soiled linen that comes in from the customer?',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: this.currentSoftware
                },
                {
                    question_type: 'current_software_chanllanges',
                    question_data: 'Are you interested in using RFID for your linen tracking?',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: [this.currentSoftwareChanllanges]
                },
                {
                    question_type: 'manage_deliveries_rental',
                    question_data: 'How do you manage your pick-ups and deliveries?',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: this.manageDeliveriesRental
                },
                {
                    question_type: 'track_rewash_linen_rental',
                    question_data: 'Are you interested in tracking your Rewash Linen, Discarded/Damaged linen etc?',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: [this.trackRewashLinenRental]
                },
                {
                    question_type: 'billing_type_for_linen_rental2',
                    question_data: 'Are you currently using any other Software to manage your laundry?',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: [this.billingTypeForLinenRental2]
                },
                {
                    question_type: 'track_rental_soiled_linen_rental',
                    question_data: 'What are the key challenges you are trying to solve by using a software? Please mention your key pain points?',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: this.trackRentalSoiledLinenRental != '' ? [this.trackRentalSoiledLinenRental + '?ques_id=writeAnswerChallengesRental'] : ''
                },
                {
                    question_type: 'route-rental',
                    question_data: 'How many routes do you run?',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: this.routeRunsRental != '' ? [this.routeRunsRental] + '?ques_id=routeRunsRental1' : ''
                },
            ];
            // Both
            const formDataBoth = [
                {
                    question_type: 'processing_type',
                    question_data: "Processing Type (Please select what represents the major part of your business e.g) If its 70 percent rentals and 30 percent COG then select rentals.",
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: [this.processingType]
                },
                {
                    question_type: 'both_customer',
                    question_data: 'Who are your customers?',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: this.bothCustomer
                },
                {
                    question_type: 'both_billing_type',
                    question_data: 'We bill our customers by',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: this.bothBillingType
                },
                {
                    question_type: 'both_track_cog_soiled_linen',
                    question_data: 'We Track Soiled Linen (Dirty Linen) when it comes in from each customer',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: [this.bothTrackCogSoiledLinen]
                },
                {
                    question_type: 'both_delivery_purpose',
                    question_data: 'For Delivery purpose, we use',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: this.bothDeliveryPurpose
                },
                {
                    question_type: 'both_cart_barcoded',
                    question_data: 'Are your Carts/Bins or Bags barcoded?',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: [this.bothCartBarcoded]
                },
                {
                    question_type: 'both_billing_type_for_linen_rental',
                    question_data: 'Are you currently using any other Software to manage your laundry?',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: [this.bothBillingTypeForLinenRental]
                },
                {
                    question_type: 'both_track_rewash_linen_rental',
                    question_data: 'Are you interested in tracking your Rewash Linen, Discarded/Damaged linen etc?',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: [this.bothTrackRewashLinen]
                },
                {
                    question_type: 'both_manage_deliveries',
                    question_data: 'How do you manage your pick-ups and deliveries?',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: this.bothManageDeliveries
                },
                {
                    question_type: 'both_route',
                    question_data: 'How many routes do you run?',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: this.both_routeRuns != '' ? [this.both_routeRuns] + '?ques_id=both_routeRuns1' : ''
                },
                {
                    question_type: 'both_track_rental_soiled_linen_rental',
                    question_data: 'What are the key challenges you are trying to solve by using a software? Please mention your key pain points?',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: this.bothTrackRentalSoiledLinenRental != '' ? [this.bothTrackRentalSoiledLinenRental + '?ques_id=both_writeAnswerChallengesRental'] : ''
                },
                {
                    question_type: 'both_rfid',
                    question_data: 'What is your business model for Linen Hire/Rentals?',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: this.bothRfid
                },
                {
                    question_type: 'both_hire_rental',
                    question_data: 'How do you bill your customers for Linen Rentals/Linen Hire?',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: this.bothHireRental
                },
                {
                    question_type: 'both_current_software',
                    question_data: 'Do you track Soiled linen that comes in from the customer?',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: this.bothCurrentSoftware
                },
                {
                    question_type: 'both_current_software_chanllanges',
                    question_data: 'Are you interested in using RFID for your linen tracking?',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: [this.bothCurrentSoftwareChanllanges]
                },
                {
                    question_type: 'customer_owned_license',
                    question_data: 'For your customers where your Process Customer Owned Linens(COG) how do you bill your customers',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: [this.customer_owned_license_val]
                },
                {
                    question_type: 'both-business',
                    question_data: 'What percentage of your business is Rentals versus Customer Owned Goods?',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: this.both_business != '' ? [this.both_business] + '?ques_id=business_rental' : ''
                },
                {
                    question_type: 'approximate_vol_both',
                    question_data: 'Approximate volume of linen processed per day',
                    lead_questionnaire_id: this.formData.lead_id,
                    selected_data: this.approximate_vol_both != '' ? [this.approximate_vol_both] + '?ques_id=approximate_vol_both' : ''
                },
            ];

            const formDataMap = {
                1: formDataCOG,
                2: formDataRental,
                3: formDataBoth
            };  
              const permission = {
      headers: {
        'X-Permission': 'lead_prospection_question' 
      }
    };
            axios.post("/admin/users/post-onboarding-questionnaire", {
                formData: formDataMap[this.checkValue]
            },permission)
                .then(() => {
                    this.isMiniLoading = false;
                    this.$toast.success("Onboarding Questions Set Successfully");
                    window.$("#modal").modal("hide");
                    this.checked = false;
                    this.checked1 = false;
                    this.check = this.checkValue === 1;
                    this.check1 = this.checkValue === 2;
                    this.check2 = this.checkValue === 3;
                })
                .catch((error) => {
                    this.isMiniLoading = false;
                    this.$toast.error(error);
                });

        },
        isCheck(event) {
            this.checkValue = event;
            this.executeSpecificPart = false;
            if (event == 1) {
                this.check1 = false;
                this.check2 = false;
                this.check = true;
            } else if (event == 2) {
                this.check = false;
                this.check2 = false;
                this.check1 = true;
            } else if (event == 3) {
                this.check = false;
                this.check1 = false;
                this.check2 = true;
            }

        },
        isChecked() {
            if (!this.checked) {
                this.checked = true;
            } else {
                this.checked = false;
                this.other_method = "";
            }
        },
        isChecked1() {
            if (!this.checked1) {
                this.checked1 = true;
            } else {
                this.checked1 = false;
                this.other_method1 = '';
            }
        },
        setSoiledLinen(event) {
            this.track_soiled_linen = event.target.value;
        },
        setDeliveryRouts(event) {
            this.rental_delivery_routs = event.target.value;
        },
        setSoiledLinenTracking(event) {
            this.we_do_tracking = event.target.value;
        },
        setCogDeliveryRouts(event) {
            this.cog_devlivery_routes = event.target.value;
        },
    },
    mounted() {
    },

};
</script>
